// extracted by mini-css-extract-plugin
module.exports = {"myButton":"InputButton_myButton__qmTg3"};